module.exports = __webpack_public_path__ + "static/media/Delete.36dc3160.svg";